var map = {
	"./gt3-full_da": [
		640,
		56
	],
	"./gt3-full_da.json": [
		640,
		56
	],
	"./gt3-full_de": [
		641,
		57
	],
	"./gt3-full_de.json": [
		641,
		57
	],
	"./gt3-full_en": [
		642,
		58
	],
	"./gt3-full_en.json": [
		642,
		58
	],
	"./gt3-full_fo": [
		643,
		59
	],
	"./gt3-full_fo.json": [
		643,
		59
	],
	"./gt3-full_no": [
		644,
		60
	],
	"./gt3-full_no.json": [
		644,
		60
	],
	"./gt3_da": [
		645,
		61
	],
	"./gt3_da.json": [
		645,
		61
	],
	"./gt3_de": [
		646,
		62
	],
	"./gt3_de.json": [
		646,
		62
	],
	"./gt3_en": [
		647,
		63
	],
	"./gt3_en.json": [
		647,
		63
	],
	"./gt3_fo": [
		648,
		64
	],
	"./gt3_fo.json": [
		648,
		64
	],
	"./gt3_no": [
		649,
		65
	],
	"./gt3_no.json": [
		649,
		65
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 7);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 955;
module.exports = webpackAsyncContext;